/* NightDrip v14 theme script. Native Shopify cart (Ajax API + Section Rendering API), subscriptions via selling plans (optionally on a separate subscription product) with weekly flavour confirmation, English + Arabic. No external libraries. */
(function () {
  'use strict';
  var ND = window.ND || {};
  var S = ND.strings || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function fill(str, n) { return String(str || '').replace('{n}', n); }

  /* Mobile menu */
  function setMenu(open) {
    var m = $('#NdMobileMenu'); if (!m) return;
    m.classList.toggle('is-open', open);
    m.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('menu-open', open);
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) setMenu(true);
    if (e.target.closest('[data-menu-close]') || e.target.closest('#NdMobileMenu nav a')) setMenu(false);
  });

  /* Cart drawer */
  function drawer() { return $('#NdCartDrawer'); }
  function openCart() { if (!drawer()) return false; document.body.classList.add('drawer-open'); var c = $('[data-cart-close]', drawer()); if (c) c.focus(); return true; }
  function closeCart() { document.body.classList.remove('drawer-open'); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]');
    if (o && ND.cartType === 'drawer' && drawer()) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) closeCart();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); setMenu(false); } });

  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function renderSections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('#NdCartDrawer'), cur = drawer();
    if (fresh && cur) { cur.innerHTML = fresh.innerHTML; setCount(fresh.getAttribute('data-cart-count-value')); }
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw j; } return j; }); });
  }

  /* Cart line quantity (drawer and cart page) */
  function changeLine(line, qty) {
    if ($('[data-cart-page]')) {
      return post(ND.routes.cart_change, { line: line, quantity: qty }).then(function () { window.location.reload(); });
    }
    var d = drawer(); if (d) d.classList.add('is-busy');
    return post(ND.routes.cart_change, { line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
      .then(function (cart) { renderSections(cart.sections); })
      .catch(function (err) { alert((err && (err.description || err.message)) || S.error); })
      .finally(function () { var d2 = drawer(); if (d2) d2.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]'); if (!b) return;
    var row = b.closest('[data-line]'); if (!row) return;
    changeLine(parseInt(row.getAttribute('data-line'), 10), Math.max(0, parseInt(b.getAttribute('data-line-qty'), 10)));
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-input]'); if (!i) return;
    var row = i.closest('[data-line]');
    changeLine(parseInt(row.getAttribute('data-line'), 10), Math.max(0, parseInt(i.value, 10) || 0));
  });

  /* Product pages */
  function initProduct(section) {
    var dataEl = $('[data-product-json]', section);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = $('form.nd-product-form', section);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var planInput = form ? $('[data-selling-plan]', form) : null;
    var addBtn = form ? $('[data-add-button]', form) : null;
    var addLabel = form ? $('[data-add-label]', form) : null;
    var errorEl = form ? $('[data-form-error]', form) : null;
    var current = null;

    /* Weekly flavour confirmation (shown only when a subscription plan is selected) */
    var conf = $('[data-sub-confirm]', section);
    var confCheck = conf ? $('[data-sub-check]', conf) : null;
    var confMix = conf ? $('[data-sub-mix]', conf) : null;
    function mixSummary() {
      return $$('[data-option-index]', section).map(function (group) {
        var mq = $('[data-mix-qty]', group);
        if (mq) { var n = parseInt(mq.value, 10) || 0; return n > 0 ? n + ' × ' + group.getAttribute('data-option-name') : null; }
        var checked = $('input[data-option-input]:checked', group), sel = $('select[data-option-input]', group);
        return checked ? checked.value : (sel ? sel.value : null);
      }).filter(Boolean).join(' · ');
    }
    function refreshConfirm() {
      if (!conf) return;
      var on = !!selectedPlan();
      conf.hidden = !on;
      if (!on) conf.classList.remove('is-flagged');
      if (confMix) { var s = mixSummary(); if (s) confMix.textContent = s; }
    }
    if (confCheck) confCheck.addEventListener('change', function () {
      if (confCheck.checked) { conf.classList.remove('is-flagged'); if (errorEl) errorEl.textContent = ''; }
    });

    var mix = $('[data-mix]', section);
    var mixTotal = mix ? parseInt(mix.getAttribute('data-mix-total'), 10) || 7 : 0;
    function mixCounts() { return $$('[data-mix-qty]', section).map(function (i) { return parseInt(i.value, 10) || 0; }); }
    function mixSum() { return mixCounts().reduce(function (a, b) { return a + b; }, 0); }
    function setMix(counts) { $$('[data-mix-qty]', section).forEach(function (i, n) { i.value = counts[n] || 0; }); }
    function maxFor(idx) {
      var avail = data.variants.filter(function (v) { return v.available; });
      if (!avail.length) return mixTotal;
      return avail.reduce(function (m, v) { return Math.max(m, parseInt(v.options[idx], 10) || 0); }, 0);
    }
    function refreshMix() {
      var sum = mixSum(), counts = mixCounts();
      var count = $('[data-mix-count]', section); if (count) count.textContent = sum;
      var bar = $('[data-mix-bar]', section); if (bar) bar.style.width = Math.min(100, sum / mixTotal * 100) + '%';
      $$('.nd-mix-row', section).forEach(function (row, idx) {
        $('[data-mix-step="-1"]', row).disabled = counts[idx] <= 0;
        $('[data-mix-step="1"]', row).disabled = sum >= mixTotal || counts[idx] >= maxFor(idx);
        row.classList.toggle('is-active', counts[idx] > 0);
      });
    }

    function selectedOptions() {
      return $$('[data-option-index]', section).map(function (group) {
        var mq = $('[data-mix-qty]', group);
        if (mq) return (parseInt(mq.value, 10) || 0) + ' ' + group.getAttribute('data-option-name');
        var checked = $('input[data-option-input]:checked', group);
        if (checked) return checked.value;
        var sel = $('select[data-option-input]', group);
        return sel ? sel.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) { return opts.every(function (o, i) { return v.options[i] === o; }); });
    }
    function selectedPlan() {
      var r = $('input[data-plan-input]:checked', section);
      return r ? r.value : '';
    }
    function refreshPrice() {
      var v = current; if (!v) { refreshConfirm(); return; }
      var plan = selectedPlan();
      $$('[data-plan-price]', section).forEach(function (el) {
        var id = el.getAttribute('data-plan-price');
        el.textContent = id ? (v.plans[id] || v.price) : v.price;
      });
      var price = $('[data-price]', section);
      if (price) price.textContent = plan && v.plans[plan] ? v.plans[plan] : v.price;
      var compare = $('[data-compare]', section);
      if (compare) { compare.textContent = plan && v.plans[plan] ? v.price : (v.compare || ''); }
      if (planInput) planInput.value = plan;
      /* Subscriptions may live on a separate product: add its matching variant when a plan is chosen */
      if (idInput) idInput.value = plan && v.sub ? v.sub : v.id;
      refreshConfirm();
    }
    function setMedia(mediaId) {
      if (!mediaId) return;
      var thumb = $('[data-thumb][data-media-id="' + mediaId + '"]', section);
      if (thumb) showThumb(thumb);
    }
    function showThumb(thumb) {
      var main = $('[data-main-media] img', section);
      if (main) { main.removeAttribute('srcset'); main.src = thumb.getAttribute('data-src'); main.alt = thumb.getAttribute('data-alt'); }
      $$('[data-thumb]', section).forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }
    function update(skipUrl) {
      var opts = selectedOptions();
      if (errorEl) errorEl.textContent = '';
      if (confCheck && !skipUrl) confCheck.checked = false; /* a changed mix must be confirmed again */
      refreshConfirm();
      if (mix) {
        refreshMix();
        var sum = mixSum(), status = $('[data-mix-status]', section);
        if (sum !== mixTotal) {
          var left = mixTotal - sum;
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = left > 0 ? fill(S.chooseMore, left) : fill(S.removeN, -left);
          if (status) status.textContent = left > 0 ? fill(S.addMore, left) : '';
          return;
        }
        if (status) status.textContent = '';
      }
      var v = findVariant(opts);
      if (!v) { if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = S.unavailable; return; }
      current = v;
      if (idInput) idInput.value = v.id;
      refreshPrice();
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? S.add : S.soldOut;
      if (mix && !v.available) {
        var st = $('[data-mix-status]', section);
        if (st) st.textContent = data.variants.some(function (x) { return x.available; }) ? S.mixStock : S.allSoldOut;
      }
      setMedia(v.media);
      if (!skipUrl && opts.length) { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); }
    }

    $$('[data-option-input]', section).forEach(function (i) { i.addEventListener('change', function () { update(); }); });
    $$('[data-plan-input]', section).forEach(function (i) { i.addEventListener('change', refreshPrice); });
    $$('[data-thumb]', section).forEach(function (t) { t.addEventListener('click', function () { showThumb(t); }); });
    $$('[data-qty-step]', section).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input');
        input.value = Math.max(1, Math.min(parseInt(input.max || 99, 10), (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10)));
      });
    });

    if (mix) {
      $$('[data-mix-step]', section).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = b.parentNode.querySelector('[data-mix-qty]');
          var cur = parseInt(input.value, 10) || 0, next = cur + parseInt(b.getAttribute('data-mix-step'), 10);
          if (next < 0 || (next > cur && mixSum() >= mixTotal)) return;
          input.value = next; update();
        });
      });
      $$('[data-mix-preset]', section).forEach(function (b) {
        b.addEventListener('click', function () {
          var p = b.getAttribute('data-mix-preset'), n = $$('[data-mix-qty]', section).length, counts = [];
          for (var i = 0; i < n; i++) counts.push(0);
          if (p === 'even') { var base = Math.floor(mixTotal / n), extra = mixTotal - base * n; for (var j = 0; j < n; j++) counts[j] = base + (j < extra ? 1 : 0); }
          else counts[parseInt(p, 10)] = mixTotal;
          setMix(counts); update();
        });
      });
      /* ?flavor=1 (2, 3) or ?flavor=Classic preselects seven of one flavour */
      var wanted = new URLSearchParams(window.location.search).get('flavor');
      if (wanted) {
        var rows = $$('.nd-mix-row', section), target = -1;
        if (/^\d+$/.test(wanted)) target = parseInt(wanted, 10) - 1;
        else rows.forEach(function (row, idx) { if (row.getAttribute('data-option-name').toLowerCase() === wanted.toLowerCase()) target = idx; });
        if (target >= 0 && target < rows.length) { var c = mixCounts().map(function () { return 0; }); c[target] = mixTotal; setMix(c); }
      }
    }
    update(true);

    if (form) {
      form.addEventListener('submit', function (e) {
        if (conf && confCheck && selectedPlan() && !confCheck.checked) {
          e.preventDefault();
          conf.hidden = false;
          conf.classList.add('is-flagged');
          if (errorEl) errorEl.textContent = conf.getAttribute('data-error') || '';
          confCheck.focus();
          return;
        }
        if (planInput) { planInput.value = selectedPlan(); planInput.disabled = !planInput.value; }
        if (idInput && current) idInput.value = selectedPlan() && current.sub ? current.sub : current.id;
        if (ND.cartType !== 'drawer' || !drawer()) return; /* native POST to /cart */
        e.preventDefault();
        if (addBtn) addBtn.classList.add('is-loading');
        var qty = $('input[name="quantity"]', form);
        var item = { id: parseInt(idInput.value, 10), quantity: qty ? parseInt(qty.value, 10) || 1 : 1 };
        var plan = selectedPlan(); if (plan) item.selling_plan = parseInt(plan, 10);
        post(ND.routes.cart_add, { items: [item], sections: ['cart-drawer'], sections_url: window.location.pathname })
          .then(function (res) { renderSections(res.sections); openCart(); })
          .catch(function (err) { if (errorEl) errorEl.textContent = (err && (err.description || err.message)) || S.error; })
          .finally(function () { if (addBtn) addBtn.classList.remove('is-loading'); if (planInput) planInput.disabled = false; });
      });
    }
  }

  function init() { $$('[data-product-section]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-product-section]'); if (s) initProduct(s); });
})();
